import {
  adminPharmacyRatingDetails,
  adminPharmacyRatingItems,
  adminPharmacyRatings,
  adminProfessionalDetails,
  adminProfessionalRatingDetails,
  adminProfessionalRatingItems,
  adminProfessionalRatings,
  getAdminPharmacistRating,
  getAdminPharmacyRating,
  getAdminPharmacyRatingItems,
  getAdminProfessionalRatingItems,
  getPharmacistDetails,
  getPharmacyDetails,
  getPharmacyRatingDetails,
  getRatingDetails,
  pharmacyDetails,
  TypeOfUser,
} from '@pharmaplan/common';
import { useAppSelector } from '../../useAppSelector';
import strings from '../../../localization';

const { pharmacy } = TypeOfUser;

const useAdminRatings = (userType: TypeOfUser) => {
  const isPharmacy = userType === pharmacy;

  const professionalRatingDetails = useAppSelector(adminProfessionalRatings);
  const professionalRatingData = useAppSelector(adminProfessionalRatingItems);
  const professionalDetailedRating = useAppSelector(
    adminProfessionalRatingDetails,
  );
  const professionalUserDetails = useAppSelector(adminProfessionalDetails);

  const pharmacyRatingDetails = useAppSelector(adminPharmacyRatings);
  const pharmacyRatingData = useAppSelector(adminPharmacyRatingItems);
  const pharmacyDetailedRating = useAppSelector(adminPharmacyRatingDetails);
  const pharmacyUserDetails = useAppSelector(pharmacyDetails);

  const { professionalRatingItems, professionalRatingQuestions } = professionalRatingData ?? {};
  const { pharmacyRatingItems, pharmacyRatingQuestions } = pharmacyRatingData ?? {};

  const professionalLabels = {
    [TypeOfUser.pharmacist]: { title: strings.pharmacistRating, backTo: strings.pharmacistList },
    [TypeOfUser.technician]: { title: strings.technicianRating, backTo: strings.techniciansList },
    [TypeOfUser.student]: { title: strings.pharmacyStudentRating, backTo: strings.pharmacyStudentsList },
  };

  const config = () => {
    if (isPharmacy) {
      return {
        userRatingItems: pharmacyRatingItems,
        ratingData: pharmacyRatingData,
        propertyId: 'pharmacyRatingItemId',
        itemId: 'pharmacyItemId',
        details: pharmacyRatingDetails,
        nameProperty: 'professionalName',
        ratingDetailsAPI: getPharmacyRatingDetails,
        userDetailsAPI: getPharmacyDetails,
        ratingAPI: getAdminPharmacyRating,
        ratingItemAPI: getAdminPharmacyRatingItems,
        questionId: 'pharmacyRatingQuestionId',
        questions: pharmacyRatingQuestions,
        detailedRating: pharmacyDetailedRating,
        user: pharmacyUserDetails?.pharmacy,
        codeProperty: 'professionalCode',
        backTo: strings.pharmacyList,
        title: strings.pharmacyRating,
      };
    }

    const { backTo, title } = professionalLabels?.[userType as keyof typeof professionalLabels] ?? {};

    return {
      userRatingItems: professionalRatingItems,
      ratingData: professionalRatingData,
      propertyId: 'professionalRatingItemId',
      itemId: 'professionalItemId',
      details: professionalRatingDetails,
      nameProperty: 'pharmacyName',
      ratingDetailsAPI: getRatingDetails,
      userDetailsAPI: getPharmacistDetails,
      ratingAPI: getAdminPharmacistRating,
      ratingItemAPI: getAdminProfessionalRatingItems,
      questionId: 'professionalRatingQuestionId',
      questions: professionalRatingQuestions,
      detailedRating: professionalDetailedRating,
      user: professionalUserDetails?.professional,
      codeProperty: 'pharmacyCode',
      backTo,
      title,
    };
  };

  return config();
};

export default useAdminRatings;
